/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Sergey Sukhenko <cyxenko@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {DamElasticDTO} from './DamElasticDTO'

export interface DamItemVersion {
  id: number;
  iid: number;
  header: string;
  syncUid?: string;
  mimeType?: string;
  enabled: boolean;
  catalogId?: number;
  terms?: string[];
  createdAt?: Date;
  deleted?: boolean;
  pos?: number;
  size: number;
  count: number;
  hideExpression?: boolean;
  documentId: number;
  updatedAt?: string;
  damItem?: DamElasticDTO
}
